@use '@/styles/tokens' as *;

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
}

.req {
  color: var(--status-danger);
}

.row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);

  @include down(sm) {
    grid-template-columns: 1fr;
  }
}

.error {
  font-size: 13px;
  color: var(--status-danger);
}
